/* Arrows for the row of in-stock calendars on a sold-out calendar's page (HEA-716,
 * snippets/sold-out-calendars.liquid). The row scrolls by itself with a finger or a trackpad; the
 * arrows are for a mouse, so they show only on a device that hovers and only while the row
 * overflows, and the one at an end turns off. Each press moves the row by the cards in view.
 * They are out of the tab order: focus on a card's title or button scrolls the row by itself.
 *
 * The row also drops a card's second add while its first is under way (HEA-1172): the theme's
 * atc-submit posts on every submit, so a double tap or a second Enter added two calendars. CSS
 * stops the second tap; this stops a submit from the keyboard, before atc-submit sees it.
 */
(function () {
  if (customElements.get('sold-out-calendars-row')) return;

  var hovers = window.matchMedia('(hover: hover)');

  class SoldOutCalendarsRow extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.sold-out-calendars_list');
      this.buttons = this.querySelectorAll('.sold-out-calendars_nav');
      if (!this.list || !this.buttons.length) return;
      this.addEventListener('submit', this.holdSecondAdd, true);
      this.update = this.update.bind(this);
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.step(Number(button.dataset.step)));
      });
      this.list.addEventListener('scroll', this.update, { passive: true });
      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.list);
      }
      hovers.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.update) hovers.removeEventListener('change', this.update);
    }

    holdSecondAdd(event) {
      var loader = event.target.querySelector('.sold-out-calendars_loader');
      if (loader && !loader.classList.contains('hidden')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    step(direction) {
      var card = this.list.querySelector('.sold-out-calendars_card');
      var gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      var width = card ? card.offsetWidth + gap : this.list.clientWidth;
      var cards = Math.max(1, Math.floor((this.list.clientWidth + gap) / width));
      this.list.scrollBy({ left: direction * cards * width, behavior: 'smooth' });
    }

    update() {
      var overflows = this.list.scrollWidth > this.list.clientWidth + 1;
      var show = hovers.matches && overflows;
      var left = Math.abs(this.list.scrollLeft);
      var end = this.list.scrollWidth - this.list.clientWidth - 1;
      var dropped = null;
      this.buttons.forEach((button) => {
        var disabled = Number(button.dataset.step) < 0 ? left <= 0 : left >= end;
        if (disabled && button === document.activeElement) dropped = button;
        button.hidden = !show;
        button.disabled = disabled;
      });
      // A disabled arrow loses focus to the page, so focus moves to the arrow that still works.
      if (dropped) {
        var other = Array.prototype.find.call(this.buttons, (button) => button !== dropped && !button.disabled && !button.hidden);
        if (other) other.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('sold-out-calendars-row', SoldOutCalendarsRow);
})();
